import { isObject, isNonEmptyString } from '@/utils/checks'
import { Location } from '../../../types/models/Location.model'

type TypeTitleMap = {
  city?: string
  country?: string
  region?: string
}

const getTypeTittleMapFromLocationList = (
  locationList: Location[]
): TypeTitleMap => {
  return locationList.filter(isObject).reduce((acc, location) => {
    const locationTypeKey = location.type
    if (
      isNonEmptyString(location.type) &&
      isNonEmptyString(location.title) &&
      !acc[locationTypeKey]
    ) {
      return {
        ...acc,
        [location.type]: location.title
      }
    }
    return acc
  }, {})
}

export default getTypeTittleMapFromLocationList
